import compute from "./compute";

export { default } from "./Environment";

export const isDevelopment = compute(window) === "development";
export const isProduction = compute(window) === "production";
export const isStaging = compute(window) === "staging";
